module.exports = __webpack_public_path__ + "static/media/safety.441fb46c.svg";